import { COM_RELOAD_USERINFO, COM_SET_BREADCRUMB, COM_SET_USER_INFO } from '../types';

const state = {
    reloadUser: false,
    breadcrumb: '',
    userInfo: {},
};

const actions = {
    setreloadUserState({ commit }, status) {
        commit(COM_RELOAD_USERINFO, status);
    },
    setBreadcrumb({ commit }, status) {
        commit(COM_SET_BREADCRUMB, status);
    },
    setUserInfo({ commit }, status) {
        commit(COM_SET_USER_INFO, status);
    },
};

const getters = {
    reloadUser: state => state.reloadUser,
    breadcrumb: state => state.breadcrumb,
    userInfo: state => state.userInfo,
};

const mutations = {
    [COM_RELOAD_USERINFO](state, status) {
        state.reloadUser = status;
    },
    [COM_SET_BREADCRUMB](state, str) {
        state.breadcrumb = str;
    },
    [COM_SET_USER_INFO](state, str) {
        state.userInfo = str;
    },
};

export default {
    state,
    mutations,
    actions,
    getters,
};